<template>
  <v-container fluid grid-list-md style="max-height:90vh !important; overflow:scroll" class="ma-0 pa-0">
    <v-card tile>
          
          <v-card-text>
            
            <v-list three-line subheader>
              <v-subheader>User Controls</v-subheader>
              <v-list-tile avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Content filtering</v-list-tile-title>
                  <v-list-tile-sub-title>Set the content filtering level to restrict apps that can be downloaded</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Password</v-list-tile-title>
                  <v-list-tile-sub-title>Require password for purchase or use password to restrict purchase</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider></v-divider>
            <v-list three-line subheader>
              <v-subheader>General</v-subheader>
              <v-list-tile avatar>
                <v-list-tile-action>
                  <v-checkbox v-model="notifications"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Notifications</v-list-tile-title>
                  <v-list-tile-sub-title>Notify me about updates to apps or games that I downloaded</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar>
                <v-list-tile-action>
                  <v-checkbox v-model="sound"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Sound</v-list-tile-title>
                  <v-list-tile-sub-title>Auto-update apps at any time. Data charges may apply</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar>
                <v-list-tile-action>
                  <v-checkbox v-model="widgets"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Auto-add widgets</v-list-tile-title>
                  <v-list-tile-sub-title>Automatically add home screen widgets</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>
        </v-card>

  </v-container>
</template>

<script>
  export default {
    components: {
      thumbImg: () => import('@/components/tienda/tumbpic'),
      categorias: () => import('@/components/tienda/categorias')
    },
    data: () => ({
      dialog: false,
      mode: 'master',
      saveLoading: false,
      loading: true,
      search: '',
      headers: [
        { text: 'Nombre', align: 'left', sortable: true, value: 'name'},
        { text: 'Categoria', align: 'center', sortable: true, value: 'categoria' },
        { text: 'Precio', align: 'center', sortable: true, value: 'precio' },
        { text: 'Exist', align: 'center', sortable: true, value: 'stock' }
      ],
      Catalogo: [],
      selected: {
          name: '',
          categorias: [],
          precio: 0.00,
          stock: 0,
          Images: []
        }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Producto' : ''
      }
    },
    created () {
      this.cargaItems()
    },
    methods: {
      addNew () {
        // todo: add default values
        this.selected = {
          name: '',
          categorias: [],
          precio: 0.00,
          stock: 0,
          Images: []
        }
        this.mode = 'detail'
      },
      cargaItems () {
        this.$System.currentUser.ref.child('Negocio').on('value', Negsnap => {
          let CatRef = this.$db.ref(`/Negocios/${Negsnap.val()}/Catalogo`)
          CatRef.on('child_added', s => {
            let i = s.val()
            i['key'] = s.key
            this.Catalogo.push(i)
          })
          CatRef.on('child_removed', snap => {
            let removed = this.Catalogo.find(item => item.key === snap.key)
            delete this.Catalogo[this.Catalogo.indexOf(removed)]
          })
          CatRef.on('child_changed', snap => {
            let changed = this.Catalogo.find(item => item.key === snap.key)
            let i = snap.val()
            console.log('changed')
            console.dir(i)
            i['key'] = snap.key
            this.Catalogo[this.Catalogo.indexOf(changed)] = i
          })
          this.loading = false
        })
      },
      editItem (item) {
        console.dir(item)
        this.selected = item
        this.mode = 'detail'
      },
      deleteItem (item) {
        if (confirm('Seguro deseas eliminarlo?')) {
          this.$db.ref(`/Negocios/${this.$System.currentUser.Negocio.id}/Catalogo`).child(item.key).delete()
        }
      },
      close () {
        this.mode = 'master'
        this.selected = {}
      },
      save () {
        this.saveLoading = true
        let d = JSON.parse(JSON.stringify(this.selected))
        delete d['key']
        console.log('saving')
        console.dir(this.selected)
        if (!this.selected.key) {
          this.$db.ref(`/Negocios/${this.$System.currentUser.Negocio.id}/Catalogo`).push(d)
          .then(ok => {
            this.saveLoading = false
            this.close()
          }).catch(err => {
            this.saveLoading = false
            this.$Bus.$emit('ALERT', {type: 'error', text: err})
          })
        } else {
          this.$db.ref(`/Negocios/${this.$System.currentUser.Negocio.id}/Catalogo/${this.selected.key}`).set(d)
          .then(ok => {
            this.saveLoading = false
            this.close()
          }).catch(err => {
            this.saveLoading = false
            this.$Bus.$emit('ALERT', {type: 'error', text: err})
          })
        }
      }
    }
  }
</script>
